import { createContext, useContext, useState, useMemo } from "react";
import Modal2D from "../components2D/interface/Modal2D";
import { slideComponents } from "../utils/consts/2dSliderInfo";

export const Modal2DContext = createContext(undefined);

export const Modal2DProvider = ({children}) => {
    const [ isOpen, setIsOpen ] = useState(false);
    const [ content, setContent ] = useState(null);
    const [ slides, setSlides ] = useState(slideComponents);
    const [ sliderIndex, setSliderIndex ] = useState(0);

    const setNewSliderIndex = (newIndex) => {
        setSliderIndex(newIndex);
    }

    const openModal = (modalContent) => {
        setContent(modalContent);

        if(!isOpen){
            setSliderIndex(0);
        }

        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
        setContent(null)
    }

    // Memoize the context value to prevent unnecessary re-renders
    const contextValue = useMemo(() => ({
        isOpen,
        openModal,
        closeModal,
        slides, 
        setSlides,
        sliderIndex,
        setNewSliderIndex
    }), [isOpen, sliderIndex]);

    const modalProps = {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal,
        slides: slides,
        setSlides: setSlides,
        sliderIndex: sliderIndex,
        setNewSliderIndex: setNewSliderIndex,
    }


    return (    
        <Modal2DContext.Provider value={contextValue}>
            {children}
            <Modal2D {...modalProps}>
                {content}
            </Modal2D>
        </Modal2DContext.Provider>
    )
};  

export const useModal2D = () => {
    const context = useContext(Modal2DContext);

    if(!context){
        throw new Error("useModal2D must be used within a Modal2DProvider");
    }

    return context;
};